<mat-card-title class="custom-card-title text-align-center">{{ data.title | translate }}</mat-card-title>

<mat-dialog-content class="p-16">
  {{ data.message | translate: { name: data.name } }}
</mat-dialog-content>

@if (data.message2) {
  <mat-dialog-content class="p-16"> {{ data.message2 | translate }}<span class="required-asterisk">*</span> </mat-dialog-content>
}

@if (data.languageDropdown) {
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="custom-mat-card">
      <mat-select [(ngModel)]="selectedLanguageId" placeholder="Select language">
        @for (lang of languages$ | async; track lang.id) {
          <mat-option [value]="lang.id">
            {{ lang.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
}

@if (data.message3) {
  <mat-dialog-content class="">
    <div>
      <span class="black-text">{{ data.note | translate }}</span>
      <span class="red-text">{{ data.message3 | translate }}</span>
    </div>
  </mat-dialog-content>
}

@if (data.requireComment) {
  <mat-dialog-content class="p-16">
    <mat-form-field class="full-width">
      <textarea [formControl]="comment" matInput rows="3" capitalizeInput></textarea>
    </mat-form-field>
  </mat-dialog-content>
}

@if (data.uploadingFiles) {
  <mat-dialog-content>
    <div class="file-upload">
      <div class="display-inline-start">
        <h3>{{ 'COMMON.UPLOAD_DOCUMENTS' | translate }}</h3>
        <mat-icon color="primary" matTooltip="{{ 'COMMON.DOCUMENT_FORMAT_INFO' | translate }}">info</mat-icon>
      </div>
      <input appFileInputReset #documentInput type="file" [accept]="allowedDocumentExtensions" (change)="onDocumentSelect($event)" hidden multiple />
      <div
        tabindex="0"
        class="upload-container"
        (click)="documentInput.click()"
        (keyup.enter)="documentInput.click()"
        (drop)="onDocumentDrop($event)"
        (dragover)="onDragOver($event)"
        matTooltip="{{ 'COMMON.DRAG_DROP_FILES' | translate }}"
      >
        <div class="placeholder-text">
          {{ 'COMMON.DRAG_DROP_FILES' | translate }}
        </div>
      </div>
    </div>
    @if (localStagedFiles.length > 0) {
      <div>
        <ul>
          @for (file of localStagedFiles; track file; let i = $index) {
            <li class="dialog-file-item">
              <span>{{ file.name }} ({{ file.size | number }} bytes)</span>
              <mat-icon class="delete-icon" (click)="removeLocalFile(i)" color="warn" matTooltip="{{ 'COMMON.DELETE_FILE' | translate }}"> delete </mat-icon>
            </li>
          }
        </ul>
      </div>
    }
  </mat-dialog-content>
}

@if (data.messageTemplate) {
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'NOTIFICATION_TYPE.MESSAGE_TEMPLATE' | translate }}</mat-label>
      <textarea [(ngModel)]="messageTemplate" matInput rows="3" required></textarea>
      @if (!messageTemplate || messageTemplate.trim().length === 0) {
        <mat-error>
          {{ 'COMMON.REQUIRED' | translate }}
        </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
}

<mat-dialog-actions align="end">
  @if (data.cancelLabel) {
    <button mat-stroked-button mat-dialog-close>{{ data.cancelLabel | translate }}</button>
  }
  <button [disabled]="data.requireComment && comment.invalid" (click)="onConfirm()" mat-flat-button color="primary">
    {{ data.acceptLabel | translate }}
  </button>
</mat-dialog-actions>
